<div class="app-data-table-container" aria-label="Reusable table container">
  <table class="app-data-table" aria-label="Reusable data table">
    <thead>
      <tr>
        <th *ngFor="let column of columns" [ngClass]="getHeaderClass(column)" [style.text-align]="getHeaderTextAlign()">
          {{ column.header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of displayedRows; let rowIndex = index; trackBy: trackByRowIndex">
        <tr>
          <td *ngFor="let column of columns; let i = index" [style.text-align]="getTextAlign(column.align)"
            [class.clickable-cell]="isClickable(column.key)" [ngClass]="getHeaderClass(column)">
            <ng-container *ngIf="isActionColumn(column.key); else nonActionCell">
              <div class="table-row-actions">
                <button class="table-row-action-btn approve" type="button"
                  (click)="onActionButtonClick($event, row, 'approve')">
                  Approve
                </button>
                <button class="table-row-action-btn reject" type="button"
                  (click)="onActionButtonClick($event, row, 'reject')">
                  Reject
                </button>
              </div>
            </ng-container>

            <ng-template #nonActionCell>
              <ng-container *ngIf="isSingleActionColumn(column.key)">
                <button class="table-row-single-action-btn" type="button"
                  (click)="onSingleActionButtonClick($event, row)">
                  {{ singleActionLabel }}
                </button>
              </ng-container>

              <ng-container *ngIf="column.key === 'action'; else nonSingleActionCell">
                <button [ngClass]="{ 'btn-blue': getSecondaryActionLabel(row, i) === 'APPROVED' }"
                  class="table-row-single-action-btn approve" type="button"
                  (click)="onSecondarySingleActionButtonClick(row, rowIndex)">
                  {{ getSecondaryActionLabel(row, i) }}
                </button>
              </ng-container>

            </ng-template>

            <ng-template #nonSingleActionCell>
              <ng-container *ngIf="isSecondarySingleActionColumn(column.key); else nonSecondarySingleActionCell">
                <button [ngClass]="{ 'btn-blue': getSecondaryActionLabel(row, i) === 'APPROVED' }"
                  class="table-row-single-action-btn approve" type="button"
                  (click)="onSecondarySingleActionButtonClick(row, rowIndex)">
                  {{ getSecondaryActionLabel(row, i) }}
                </button>
              </ng-container>
            </ng-template>

            <ng-template #nonSecondarySingleActionCell>
              <ng-container *ngIf="isAccordionColumn(column.key); else regularCell">
                <button class="table-row-accordion-btn" type="button" (click)="toggleAccordion($event, row)">
                  <span class="icon accordion-icon" aria-hidden="true">{{ isExpanded(row) ? 'expand_more' :
                    'chevron_right'
                    }}</span>
                  <span>{{ getCellValue(row, column.key) }}</span>
                </button>
              </ng-container>
            </ng-template>

            <ng-template #regularCell>
              <span *ngIf="isClickable(column.key); else plainCell" class="clickable-value"
                (click)="onCellClick(row, column.key)" role="button" tabindex="0"
                (keyup.enter)="onCellClick(row, column.key)">
                {{ getCellValue(row, column.key) }}
              </span>

              <ng-template #plainCell>
                <!-- Normal columns / sub column values binded here -->
                <span
                  *ngIf="column.key !== 'classification_reason' && column.key !== 'classification' && column.key !== 'validator_reason' ">
                  {{ getCellValue(row, column.key) }}
                </span>

                <!-- Classification reason -->
                <span *ngIf="column.key === 'classification_reason' && !isViewMore(row, column.key, rowIndex)">
                  {{ getCellValue(row, column.key)?.toString() | slice:0:50 }}...
                  <a class="view-more-btn" type="button" (click)="toggleViewMore(row, column.key, rowIndex)">
                    View More
                  </a>
                </span>

                <span *ngIf="column.key === 'classification_reason' && isViewMore(row, column.key, rowIndex)">
                  {{ getCellValue(row, column.key) }}
                  <a class="view-less-btn" type="button" (click)="toggleViewMore(row, column.key, rowIndex)">
                    View Less
                  </a>
                </span>

                <!-- Classification dropdown -->
                <ng-container *ngIf="column.key === 'classification'">
                  <select class="classification-dropdown" (change)="onClassificationChange($event, row, rowIndex)">
                  <option *ngFor="let option of classificationList" [value]="option.value"
                    [selected]="option.value === getCellValue(row, column.key)">
                    {{ option.name }}
                  </option>
                  </select>
                </ng-container>

                <ng-container *ngIf="column.key === 'validator_reason'">
                  <input type="text" 
                    class="validator-reason-input"
                    [value]="getCellValue(row, column.key)" 
                    [disabled]="!isRowModified(rowIndex)"
                    [class.disabled]="!isRowModified(rowIndex)"
                    (blur)="onChangeValidationReason(row, rowIndex, $event.target.value)"
                    placeholder="Enter reason..." />
                </ng-container>

              </ng-template>
            </ng-template>
          </td>
        </tr>

        <tr *ngIf="isExpanded(row)">
          <td [attr.colspan]="columns.length" class="app-data-table-expanded-row">
            <app-data-table [columns]="childColumns" [rows]="getChildRows(row)" [paginateRows]="true"
              [pageSize]="childPageSize" [singleActionKey]="childSingleActionKey"
              [singleActionLabel]="childSingleActionLabel" [secondarySingleActionKey]="childSecondarySingleActionKey"
              [secondarySingleActionLabel]="childSecondarySingleActionLabel"
              [secondarySingleActionLabelFn]="childSecondarySingleActionLabelFn"
              (singleActionClick)="singleActionClick.emit($event)"
              (secondarySingleActionClick)="secondarySingleActionClick.emit($event)"
              (refreshData)="refreshData.emit($event)">
            </app-data-table>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="displayedRows.length === 0">
        <td class="app-data-table-empty" [attr.colspan]="columns.length || 1">No records found</td>
      </tr>
    </tbody>
  </table>

  <div class="table-pagination-controls" *ngIf="shouldShowPagination" aria-label="Table pagination">
    <span class="table-pagination-meta">
      Showing {{ startRecordIndex }}-{{ endRecordIndex }} of {{ totalRows }} (Page {{ currentPage }} of {{ totalPages
      }})
    </span>

    <button type="button" class="table-pagination-icon-button icon" (click)="goToPreviousPage()"
      [disabled]="currentPage === 1" aria-label="Previous page">
      chevron_left
    </button>

    <button type="button" class="table-pagination-icon-button icon" (click)="goToNextPage()"
      [disabled]="currentPage === totalPages" aria-label="Next page">
      chevron_right
    </button>
  </div>
</div>